import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import AppFooter from '../application/footer/Footer';
import Header from '../application/header/Header';
// Removed QueryProvider - Providers.tsx already provides QueryClientProvider
// Removed UserInformation - Providers.tsx already provides UserInformation

const Root: React.FC = () => {
  return (
    <Box 
      data-testid="root-container"
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh',
        backgroundColor: '#E7EFF5',
        margin: 0,
        padding: 0,
        width: '100%'
      }}
    >
      <Header />
      <Box 
        component="main" 
        data-testid="main-content"
        sx={{ 
          flex: 1,
          width: '100%',
          margin: 0,
          padding: '0px',
          boxSizing: 'border-box'
        }}
      >
        <Outlet />
      </Box>
      <Box sx={{ padding: '40px' }} data-testid="footer-container">
        <AppFooter />
      </Box>
    </Box>
  );
};

export default Root; 